import Vue from 'vue'
import VeeValidate from 'vee-validate'
import Notify from 'vue-notifyjs'
import App from './App'
import router from './router'
import store from './store'
import { i18n } from './locale'
import VModal from 'vue-js-modal'
import VueVisible from 'vue-visible'
import VTooltip from 'v-tooltip'
import OnoffToggle from 'vue-onoff-toggle'

import './assets/styles/style.scss'
// Globally register components
Vue.use(VeeValidate)
Vue.use(Notify, { type: 'primary', timeout: 5000 })
Vue.use(VModal, { dialog: true, dynamic: true, injectModalsContainer: true })
Vue.use(VueVisible)
Vue.use(VTooltip)
Vue.use(OnoffToggle)
Vue.config.productionTip = false

Object.defineProperty(Vue.prototype, '$eventBus', {
  get () {
    return this.$root.eventBus
  }
})

const eventBus = new Vue()

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  data: {
    eventBus
  },
  render: h => h(App)
}).$mount('#app')
